const breederPuppyListFilters = {
    state: {
      filters: {}
    },
    mutations: {
      // Mutation to set a filter based on the label
      setPuppyListFilter(state, { label, value }) {
        state.filters[label] = value;
      },
      resetPuppyListFilters(state) {
        state.filters = {};
      }
    },
    actions: {
      // Action to apply a filter
      applyPuppyListFilter({ commit }, { label, value }) {
        commit('setPuppyListFilter', { label, value });
      },
      resetPuppyListFilters({ commit }) {
        commit('resetPuppyListFilters');
      }
    },
    getters: {
      getPuppyListFilters: (state) => (label) => {
        return state.filters[label] || null;
      }
    }
  };
  
  export default breederPuppyListFilters;
  